import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49b00df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = {
  for: "email",
  class: "form-label fw-bold"
}
const _hoisted_3 = {
  class: "mb-6",
  "data-kt-password-meter": "true"
}
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "form-label fw-bold" }
const _hoisted_6 = { class: "position-relative mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px" })
], -1))
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "mb-8" }
const _hoisted_12 = { class: "form-label fw-bold" }
const _hoisted_13 = { class: "position-relative mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/svg/files/show-password.svg",
  alt: ""
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  type: "submit",
  class: "result-btn w-100 fs-4"
}
const _hoisted_17 = { class: "indicator-label" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/svg/files/arrow-right.svg",
  class: "px-2"
}, null, -1))
const _hoisted_19 = { class: "indicator-progress" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "medical-records-form-wrapper w-100 w-md-50 mb-15",
    onSubmit: $setup.onSubmit,
    autocomplete: "off",
    novalidate: "novalidate",
    "validation-schema": $setup.registrationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("E-mail Address")), 1),
        _createVNode(_component_Field, {
          class: "form-control fw-normal",
          type: "email",
          placeholder: _ctx.$t('E-mail Address'),
          name: "email",
          disabled: $setup.disableUserInputEmail,
          modelValue: $setup.userEmail,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userEmail) = $event))
        }, null, 8, ["placeholder", "disabled", "modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "email",
          class: "invalid-input-alert mx-1 mt-1"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Password")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              class: "form-control fw-normal password-input",
              placeholder: _ctx.$t('Password'),
              name: "password",
              autocomplete: "off",
              type: $setup.isPasswordHidden ? 'password' : 'text'
            }, null, 8, ["placeholder", "type"]),
            _createElementVNode("a", {
              class: "show-password-icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.togglePassword('password')))
            }, _hoisted_8),
            _createVNode(_component_ErrorMessage, {
              name: "password",
              class: "invalid-input-alert mx-1 mt-1"
            })
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(
            "Use 12 or more characters with a mix of letters, numbers & symbols."
          )), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Confirm Password")), 1),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Field, {
            class: "form-control fw-normal password-input",
            type: $setup.isConfirmationPasswordHidden ? 'password' : 'text',
            placeholder: _ctx.$t('Confirm Password'),
            name: "password_confirmation",
            autocomplete: "off"
          }, null, 8, ["type", "placeholder"]),
          _createElementVNode("a", {
            class: "show-password-icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.togglePassword('confirmation_password')))
          }, _hoisted_15),
          _createVNode(_component_ErrorMessage, {
            name: "password_confirmation",
            class: "invalid-input-alert mx-1 mt-1"
          })
        ])
      ]),
      _createElementVNode("button", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, [
          _createTextVNode(_toDisplayString(_ctx.$t("Sign Up")) + " ", 1),
          _hoisted_18
        ]),
        _createElementVNode("span", _hoisted_19, [
          _createTextVNode(_toDisplayString(_ctx.$t("Please wait")) + "... ", 1),
          _hoisted_20
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema"]))
}